import React from 'react';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

/*
Call this with
  <StateSelector
    label="<Text to appear in label>" // defaults to "State"
    value="<state to start with>" // e.g. "CA".  defaults to "", which is good
    onChange={<function to call when an option is selected>}
  />
*/

const myStyles = (theme) => ({
  root: {
    '& label': {
      marginTop: '-10px',
      marginLeft: '12px',
    },
    '& input': {
      paddingLeft: '12px !important',
    },
    '& .Mui-focused': {
      color: '#888',
    },
    '& .MuiInput-underline': {
      '&:after': {
        borderColor: theme.palette.secondary.main,
      },
    },
  },
});

class StateSelector extends React.Component {
  stateOptions = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District Of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
  ];

  handleChange(option) {
    this.props.onChange(option ? option.value : '');
  }

  render() {
    const { classes, label, value } = this.props;
    const valueObj = this.stateOptions.find((vo) => vo.value === value);
    const labelToShow = valueObj ? ' ' : label ? label : 'State';

    return (
      <Autocomplete
        className={classes.root}
        options={this.stateOptions}
        autoHighlight
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} label={labelToShow} variant="standard" />}
        value={valueObj}
        onChange={(event, option) => this.handleChange(option)}
        onOpen={
          /* a hack to prevent past values cluttering UI*/ (event) => {
            event.target.autocomplete = 'new-password';
          }
        }
      />
    );
  }
}

export default withStyles(myStyles)(StateSelector);
